import { render } from "./IconUnlock.vue?vue&type=template&id=0176a4b2"
import script from "./IconUnlock.vue?vue&type=script&lang=ts"
export * from "./IconUnlock.vue?vue&type=script&lang=ts"
script.render = render

export default script